import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/DependencyTreeWrap.tsx";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { useStore } from 'effector-react';
import { useSnackbar } from 'notistack';
import * as api from '@gmini/sm-api-sdk';
import { isNotEmpty } from '@gmini/utils';
import { getViewerRefs } from "../Common/utils";
import { getNode } from "../../classifier-service";
import { isBimNode, isReferenceNode } from "../../classifier-service/Node";
import { getRefFromPathKey } from "../ClassifierTree/utils";
import { pendingMapClassifier$ } from "../ClassifierTree/model/pendingModel";
import { TreeLoader, operationsPending$ } from "../TreeLoader";
import { NodeLayout } from "./NodeLayout";
import { getInclusionKey, translateInclusionMessage } from "./Inclusion";
import { DependencyTree } from "./DependencyTree";
import { buildIdVersionKey } from "./model";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DependencyTreeWrap = function DependencyTreeWrap(_ref) {
  var searchModel = _ref.searchModel,
      dependencyExpandModel = _ref.dependencyExpandModel,
      loadNodeInclusion = _ref.loadNodeInclusion,
      filteredFlatTree$ = _ref.filteredFlatTree$,
      inclusionStore$ = _ref.inclusionStore$,
      dependencyTreeModel = _ref.dependencyTreeModel,
      loadNodeInclusionByStandardSize = _ref.loadNodeInclusionByStandardSize,
      currentUserClassifier$ = _ref.currentUserClassifier$,
      nodes$ = _ref.nodes$,
      dependencyCheckedModel = _ref.dependencyCheckedModel,
      inclusionStatusWithTranscript = _ref.inclusionStatusWithTranscript,
      sourceClassifiersLoaded$ = _ref.sourceClassifiersLoaded$,
      searchSourceData$ = _ref.searchSourceData$,
      selectForgeRefs = _ref.selectForgeRefs,
      dynamicGroupsConditions = _ref.dynamicGroupsConditions,
      selectedSourceNodes$ = _ref.selectedSourceNodes$,
      sources = _ref.sources,
      openedFilterPanel$ = _ref.openedFilterPanel$,
      seoEventHandler = _ref.seoEventHandler;
  var searchMatched$ = searchModel.searchMatched$;
  var currentUserClassifier = useStore(currentUserClassifier$, {
    loc: {
      file: _effectorFileName,
      line: 109,
      column: 32
    },
    name: "DependencyTreeWrap",
    sid: "DependencyTreeWrap /src/classifier-editor/DependencyTree/DependencyTreeWrap.tsx [109, 32]"
  });
  var nodes = useStore(nodes$, {
    loc: {
      file: _effectorFileName,
      line: 110,
      column: 16
    },
    name: "DependencyTreeWrap",
    sid: "DependencyTreeWrap /src/classifier-editor/DependencyTree/DependencyTreeWrap.tsx [110, 16]"
  });
  var pendingMap = useStore(pendingMapClassifier$, {
    loc: {
      file: _effectorFileName,
      line: 111,
      column: 21
    },
    name: "DependencyTreeWrap",
    sid: "DependencyTreeWrap /src/classifier-editor/DependencyTree/DependencyTreeWrap.tsx [111, 21]"
  });
  var operationsPending = useStore(operationsPending$, {
    loc: {
      file: _effectorFileName,
      line: 112,
      column: 28
    },
    name: "DependencyTreeWrap",
    sid: "DependencyTreeWrap /src/classifier-editor/DependencyTree/DependencyTreeWrap.tsx [112, 28]"
  });
  var sourceClassifiersLoaded = useStore(sourceClassifiersLoaded$, {
    loc: {
      file: _effectorFileName,
      line: 113,
      column: 34
    },
    name: "DependencyTreeWrap",
    sid: "DependencyTreeWrap /src/classifier-editor/DependencyTree/DependencyTreeWrap.tsx [113, 34]"
  });
  var inclusionStore = useStore(inclusionStore$, {
    loc: {
      file: _effectorFileName,
      line: 114,
      column: 25
    },
    name: "DependencyTreeWrap",
    sid: "DependencyTreeWrap /src/classifier-editor/DependencyTree/DependencyTreeWrap.tsx [114, 25]"
  });
  var inclusionMap = currentUserClassifier && inclusionStore[currentUserClassifier.id];
  var loadedDeps = currentUserClassifier === null || currentUserClassifier === void 0 ? void 0 : currentUserClassifier.sourceClassifiers.map(function (r) {
    return getNode(nodes$.getState(), r);
  }).filter(isNotEmpty).every(function (_ref2) {
    var id = _ref2.id,
        version = _ref2.version;
    return sourceClassifiersLoaded[buildIdVersionKey({
      id: id,
      version: version
    })];
  });
  React.useEffect(function () {
    if (currentUserClassifier !== null && currentUserClassifier !== void 0 && currentUserClassifier.id && currentUserClassifier.version) {
      api.getSourceClassifiersVersions.submit({
        id: currentUserClassifier.id,
        version: currentUserClassifier.version
      });
    }
  }, [currentUserClassifier === null || currentUserClassifier === void 0 ? void 0 : currentUserClassifier.id, currentUserClassifier === null || currentUserClassifier === void 0 ? void 0 : currentUserClassifier.version]);
  React.useEffect(function () {
    if (loadedDeps && currentUserClassifier) {
      loadNodeInclusion === null || loadNodeInclusion === void 0 ? void 0 : loadNodeInclusion(currentUserClassifier);
    }
  }, [currentUserClassifier, loadNodeInclusion, loadedDeps]);
  var findAnywhere = React.useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ref, path) {
      var _node2, _node3;

      var node, viewerRefs;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (currentUserClassifier) {
                _context.next = 2;
                break;
              }

              throw new Error('currentUserClassifier is not defined');

            case 2:
              node = getNode(nodes, ref);

              if (node && isReferenceNode(node)) {
                node = getNode(nodes, node.element);
              }

              if (((_node2 = node) === null || _node2 === void 0 ? void 0 : _node2.type) === 'AssemblyClassifierNode' && node.assemblyModelRef) {
                node = getNode(nodes, node.assemblyModelRef.element);
              }

              if (!(((_node3 = node) === null || _node3 === void 0 ? void 0 : _node3.type) === 'BimElementNode')) {
                _context.next = 8;
                break;
              }

              _context.next = 8;
              return api.UserClassifier.findElementEverywhere.defaultContext({
                classifierId: currentUserClassifier.id,
                classifierVersion: currentUserClassifier.version,
                elementId: node.id,
                modelId: node.modelId,
                version: node.modelVersion
              });

            case 8:
              if (!(node && isBimNode(node))) {
                _context.next = 14;
                break;
              }

              searchModel.setSearchNodes({
                type: 'search',
                nodes: [{
                  node: node,
                  path: path
                }]
              });
              _context.next = 12;
              return getViewerRefs(node, nodes);

            case 12:
              viewerRefs = _context.sent;

              if (viewerRefs) {
                selectForgeRefs(viewerRefs);
              }

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [currentUserClassifier, nodes, searchModel, selectForgeRefs]);
  var onPending = React.useCallback(function (key) {
    return !!pendingMap[key];
  }, [pendingMap]);

  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var notify = React.useCallback(function (reason) {
    enqueueSnackbar(reason, {
      variant: 'error'
    });
  }, [enqueueSnackbar]);
  var removeRef = React.useCallback(function (params) {
    api.UserClassifier.removeDependency.defaultContext.submit(params);
    seoEventHandler === null || seoEventHandler === void 0 ? void 0 : seoEventHandler(params.sourceClassifierId, params.type, 'remove');
  }, [seoEventHandler]);
  var onLoadInclusion = React.useCallback(function (params) {
    if (!currentUserClassifier) {
      throw new Error('currentUserClassifier is not defined');
    }

    loadNodeInclusionByStandardSize === null || loadNodeInclusionByStandardSize === void 0 ? void 0 : loadNodeInclusionByStandardSize({
      id: currentUserClassifier.id,
      version: currentUserClassifier.version,
      modelVersion: params.modelVersion,
      standardSizeId: params.standardSizeId
    });
  }, [currentUserClassifier, loadNodeInclusionByStandardSize]);

  var getInclusion = function getInclusion(key) {
    var _node = getNode(nodes, getRefFromPathKey(key));

    if (inclusionMap && _node) {
      var included = inclusionMap === null || inclusionMap === void 0 ? void 0 : inclusionMap[getInclusionKey(_node)];
      return included || [];
    }

    return null;
  };

  if (!currentUserClassifier) {
    return null;
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TreeLoader, {}), /*#__PURE__*/_jsx(DependencyTree, {
      dynamicGroupsConditions: dynamicGroupsConditions,
      notify: notify,
      nodes$: nodes$,
      isIncluded: getInclusion,
      currentEntity: currentUserClassifier,
      treeModel: {
        flatTree$: filteredFlatTree$
      },
      checkedModel: dependencyCheckedModel,
      expandModel: dependencyExpandModel,
      selectedFromOtherTreeCount: 0,
      onFindAnywhere: findAnywhere,
      onDelete: removeRef,
      onPending: onPending,
      hideCtxMenu: operationsPending,
      selectedPath: {
        path: []
      },
      onLoadInclusion: onLoadInclusion,
      sources: sources,
      selectedSourceNodes$: selectedSourceNodes$,
      openedFilterPanel$: openedFilterPanel$,
      renderNodeLayout: function renderNodeLayout(_ref4) {
        var node = _ref4.node,
            nodeLayoutProps = _ref4.nodeLayoutProps,
            path = _ref4.path;

        var nextProps = _objectSpread({}, nodeLayoutProps);

        if (inclusionMap) {
          var _key = path[path.length - 1];
          var includedMap = path.reduce(function (acc, next) {
            acc[next] = getInclusion(next) || [];
            return acc;
          }, {});
          var parentIncluded = Object.keys(includedMap).find(function (val) {
            return val !== _key && !!includedMap[val].includes('SELF_INCLUDED');
          });
          var included = parentIncluded ? [].concat(_toConsumableArray(includedMap[_key]), ['PARENT_INCLUDED']) : includedMap[_key];

          if (included.length) {
            var color = 'rgba(0, 3, 53, 0.4)';

            if (nextProps.highlightedInSearch) {
              color = 'rgba(0,3,53, 0.4)';
            }

            nextProps.textStyle = _objectSpread(_objectSpread({}, nextProps.textStyle), {}, {
              color: color
            });
            nextProps.tooltipTitle = translateInclusionMessage(inclusionStatusWithTranscript, _toConsumableArray(new Set(included)));
          }
        }

        return /*#__PURE__*/_jsx(NodeLayout, _objectSpread({}, nextProps));
      },
      searchSourceData$: searchSourceData$,
      searchMatched$: searchMatched$
    })]
  });
};